import template from './invoice.html';
import controller from './invoice.controller';

let invoiceComponent = {
    restrict: 'E',
    require: {
        booking: '^booking'
    },
    bindings: {
        "data": '<'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default invoiceComponent;



// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/invoice/invoice.component.js